<template>
  <div :class="classname" class="section">
    <div class="usps__container">
      <h2 v-if="!noHeadline" class="usps__headline">
        {{ computedHeadline }}
      </h2>
      <ul class="usps__items">
        <li v-for="item in $options.items" :key="item" class="usps__item">
          <format-sprite :id="item" class="usps__sprite" :modifiers="spriteModifiers" />
          <p class="usps__label" v-html="usp(item)" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import bemBlockModifiers from "@/utils/bem-block-modifiers"
import FormatSprite from "./usp-sprite"
import globals from "@/utils/globals"

export default {
  name: "Usps",
  components: {
    FormatSprite
  },
  items: ["key-ideas", "growing", "hand-picked"],
  totalBooks: globals.totalBooks,
  totalCategories: globals.totalCategories,
  totalUsers: globals.totalUsers,
  props: {
    modifiers: { type: Array, default: () => [] },
    spriteModifiers: { type: Array, default: () => [] },
    noHeadline: { type: Boolean, default: false },
    headline: { type: String, default: null },
    usps: { type: Object, default: () => {} }
  },
  computed: {
    classname() {
      return bemBlockModifiers("usps", this.modifiers)
    },
    computedHeadline() {
      return this.headline || this.$t("headline")
    }
  },
  methods: {
    usp(key) {
      const params = {
        totalBooks: this.$options.totalBooks,
        totalCategories: this.$options.totalCategories,
        totalUsers: this.$options.totalUsers
      }

      if (this.usps && this.usps[key]) {
        return this.usps[key]
      } else {
        return this.$t(`items.${key}`, params)
      }
    }
  },
  i18n: {
    messages: {
      en: {
        headline: "Blinkist brings you",
        items: {
          "key-ideas":
            "<strong>Key ideas in 15 min</strong> with over {totalBooks} Blinks in {totalCategories} categories",
          "growing": "<strong>{totalUsers} million</strong> people growing with Blinkist everyday",
          "hand-picked": "<strong>Hand-picked recommendations</strong>, collections curated by experts, and more"
        }
      },
      de: {
        headline: "Das ist Blinkist:",
        items: {
          "key-ideas": "<strong>Kernaussagen</strong> der besten Sachbücher in 15 min pro Titel",
          "growing": "Mehr als <strong>{totalUsers} Millionen</strong> Nutzer auf der ganzen Welt",
          "hand-picked": "<strong>Personalisierte Empfehlungen</strong> passend zu deinen Interessen und Zielen"
        }
      },
      es: {
        headline: "Blinkist te ofrece",
        items: {
          "key-ideas": "<strong>Las ideas clave</strong> de los mejores libros en 15 minutos",
          "growing": "Más de <strong>{totalUsers} millones</strong> de personas crecen con Blinkist cada día",
          "hand-picked": "<strong>Recomendaciones personalizadas</strong>, colecciones seleccionadas por expertos y mucho más"
        }
      }
    }
  }
}
</script>

<style lang="scss">
.usps {
  &__container {
    @include container;
  }

  &__headline {
    @include h2;

    margin-bottom: $spacing-24;

    text-align: center;

    @include media(min-width, m) {
      margin-bottom: $spacing-32;
    }
  }

  &__items {
    @include grid-css;

    justify-items: center;
  }

  &__item {
    @include grid-css-element(12);

    display: flex;
    align-items: center;

    &:not(:last-child) {
      margin-bottom: $spacing-32;
    }

    @include media(min-width, m) {
      @include grid-css-element(4);

      flex-direction: column;
      max-width: rem(207px);
      margin-bottom: 0;

      text-align: center;
    }

    @include media(min-width, l) {
      max-width: rem(296px);
    }
  }

  &__sprite {
    display: block;
    flex-shrink: 0;
    margin-right: $spacing-16;

    @include media(min-width, m) {
      margin-right: 0;
      margin-bottom: $spacing-8;
    }
  }

  &__label {
    @include p0;

    margin: 0;
  }

  &--background-pale-mint-grey {
    background-color: $pale-mint-grey;
  }
}
</style>
